import { createGenericStore } from '../store/genericStore';
import { BaseStatus } from './types';

export const useStatusStore = createGenericStore<BaseStatus>();
